import {
  colorBorderSecondary,
  colorTableOperationIcon,
} from '@atlas-frontend/design-tokens';
import { Flex } from 'antd';
import { FC, PropsWithChildren } from 'react';
import { Lock } from 'react-feather';
import styled from 'styled-components';
import { Padding } from './Padding';

export const ForbiddenData: FC<PropsWithChildren> = (props) => {
  return (
    <Padding vertical>
      <Flex vertical gap="small" justify="center" align="center">
        <Lock size={40} color={colorBorderSecondary} />
        <Description>{props.children}</Description>
      </Flex>
    </Padding>
  );
};

const Description = styled.div`
  text-align: center;
  color: ${colorTableOperationIcon};
  white-space: pre-line;
`;
